import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/state/AuthContext';

/**
 * Open-redirect protection: only paths that start with `/dashboard` are accepted
 * as `next` values when bouncing back from /auth.
 */
const SAFE_NEXT = /^\/dashboard(\/.*)?$/;

interface Props { children: ReactNode }

export function AuthGuard({ children }: Props) {
  const { status } = useAuth();
  const loc = useLocation();

  if (status === 'unknown') {
    return <div className="container" style={{ padding: 64 }}>Chargement…</div>;
  }
  if (status === 'unauthenticated') {
    const next = SAFE_NEXT.test(loc.pathname + loc.search) ? loc.pathname + loc.search : '/dashboard';
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}
